/* assets/lumen-product-title.js
   LUMEN — 상품명 파싱
   "[컬렉션명] 상품명 (컬러명)" 형식의 제목을 분리 렌더링
   · .name-collection : 대괄호 안 컬렉션 태그 (선택)
   · .name-product    : 상품명
   · .name-color      : 괄호 안 컬러명 (선택, opacity 0.85)
*/

(function () {
  'use strict';

  function splitProductTitle(el) {
    var text = el.textContent.trim();

    // 1. 컬렉션 태그 추출: "[LUMEN X IHNN] ..." 형태
    var collectionTag = '';
    var collectionMatch = text.match(/^\[(.+?)\]\s*/);
    if (collectionMatch) {
      collectionTag = collectionMatch[1].trim();
      text = text.replace(collectionMatch[0], '').trim();
    }

    // 2. 색상 추출: "상품명 (컬러명)" 형태
    var productName = text;
    var colorName = '';
    var colorMatch = text.match(/^(.+?)\s*\((.+)\)\s*$/);
    if (colorMatch) {
      productName = colorMatch[1].trim();
      colorName = colorMatch[2].trim();
    }

    // 파싱 결과가 없으면 원문 유지
    if (!collectionTag && !colorName) return;

    // 3. HTML 조합
    var html = '';
    if (collectionTag) {
      html += '<span class="name-collection">' + collectionTag + '</span><br>';
    }
    html += '<span class="name-product">' + productName + '</span>';
    if (colorName) {
      html += '<br><span class="name-color">' + colorName + '</span>';
    }

    el.innerHTML = html;

    // 4. 스타일 적용
    if (collectionTag) {
      var collEl = el.querySelector('.name-collection');
      collEl.style.fontFamily = '"Surt Normal", sans-serif';
      collEl.style.fontSize = '11px';
      collEl.style.opacity = '0.7';
      collEl.style.letterSpacing = '0.025em';
      collEl.style.display = 'inline-block';
      collEl.style.paddingBottom = '10px';
    }
    if (colorName) {
      el.querySelector('.name-color').style.opacity = '0.85';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* .product__title 내 h1, h2 모두 처리
       (Dawn main-product: h1 = 단독 표시, h2.h1 = 링크 내부) */
    document.querySelectorAll('.product__title h1, .product__title h2').forEach(splitProductTitle);
  });
})();
